<template>
  <v-list dense nav>
    <div v-if="this.user.isAUserOfBothPlatforms && !this.mini" class="link-container">
      <a target="_blank" href="https://platform.mikmak.ai/#/dashboard/exec_sum " class="link-to-other-platform">Open MikMak 3.0</a>
      <v-icon small style="padding-left: 4px; padding-bottom: 2px;">mdi-open-in-new</v-icon>
    </div>
    <v-menu top min-width="186px" :offset-x="true">
      <template v-slot:activator="{ on }">
        <v-list-item :class="listClass" v-on="on">
          <v-list-item-avatar left class="mr-2">
            <v-img v-if="userPicture" :src="userPicture" max-height="36px" max-width="36px"/>
            <v-icon v-else small>mdi-account</v-icon>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title>
              {{ userDisplayName }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>
      <v-list class="logout-popup" :style="logoutPopupStyle">
        <v-list-item @click.stop="logout">
          <v-list-item-title>Logout</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </v-list>
</template>

<script>

export default {
  props: {
    user: {
      type: Object,
      required: true,
    },
    mini: Boolean,
  },
  computed: {
    userDisplayName() {
      const { name, given_name, nickname } = this.user;

      return name || given_name || nickname || '';
    },
    userPicture() {
      return this.user?.picture;
    },
    listClass() {
      return this.mini ? '' : 'footer-wrapper';
    },
    logoutPopupStyle() {
      const padding = this.mini ? '4px 0' : '5px 0';

      return `padding: ${padding}`;
    },
  },
  methods: {
    logout() {
      const { host, protocol } = window.location;

      window.localStorage.removeItem('mm-platform-user');
      window.localStorage.removeItem('mmPlatformBrandIdFilter');
      window.localStorage.setItem('mm-platform-login-redirect-path',
        '/dashboard/insights',
      );

      this.$auth.logout({
        returnTo: `${protocol}//${host}/login-redirect`,
      });
    },
  },
};
</script>

<style scoped>
.logout-popup {
  font-weight: 700;
}
.footer-wrapper {
  border: 1px solid white;
}
.link-to-other-platform {
  color: white !important;
  font-size: 14px;
  padding-bottom: 2px;
  text-decoration: none;
}
.link-container {
  padding: 10px;
  border-radius: 4px;
}
.link-container:hover {
  background: rgba(255, 255, 255, 0.096) !important;
}

</style>
